module.exports = __webpack_public_path__ + "static/media/1.ee0ca855.png";